import type { PrepFilter } from '@/utils/prep-filter-utils';
import { SegmentedControl } from '@/components/common/SegmentedControl';

interface PrepFilterBarProps {
  activeFilter: PrepFilter;
  counts: Record<PrepFilter, number>;
  onChange: (filter: PrepFilter) => void;
}

const FILTER_LABELS: Record<PrepFilter, string> = {
  all: 'All',
  due: 'Due',
  overdue: 'Overdue',
  blocked: 'Blocked',
};

const FILTER_ORDER: PrepFilter[] = ['all', 'due', 'overdue', 'blocked'];

export function PrepFilterBar({ activeFilter, counts, onChange }: PrepFilterBarProps) {
  const options = FILTER_ORDER.map((filter) => ({
    value: filter,
    label: FILTER_LABELS[filter],
    badge: counts[filter],
  }));

  return (
    <div className="px-4 pt-3 pb-2 overflow-x-auto" data-testid="prep-filter-bar">
      <SegmentedControl
        options={options}
        value={activeFilter}
        onChange={(v) => onChange(v as PrepFilter)}
      />
    </div>
  );
}
